<nav class="navbar navbar-expand-lg navbar-dark bg-dark">
    
    <a class="navbar-brand" [routerLink]="['/']">
        <img src="./assets/images/logo_AntonioAlfano.svg" width="195" height="65" class="d-inline-block align-top" alt="">
      </a>

    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarColor01" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
    </button>

    <div class="navbar-collapse collapse w-100 order-3 dual-collapse2" id="navbarCollapse">        
        <ul class="navbar-nav ml-auto">
            <p class="font-weight-bold text-secondary">Seguinos en </p>
            <li class="nav-item">
                <a class="nav-link" target="_blank" href="https://www.facebook.com/pages/category/Local-Business/Antonio-Alfano-Cia-961479054220551/"><img src="./assets/images/logo_facebook.svg" width="30" height="30"></a>
            </li>
            <li class="nav-item">
                <a class="nav-link" target="_blank" href="https://www.instagram.com/almacen_colon/"><img src="./assets/images/logo_instagram.svg" width="30" height="30"></a>
            </li>
            <li class="nav-item">
                <a class="nav-link" target="_blank" href="https://www.youtube.com/channel/UCuoYKGLGUcZ-zW_f6C2ZlcQ"><img src="./assets/images/logo_youtube.svg" width="30" height="30"></a>
            </li>
        </ul>
    </div>

  </nav>